import { computed, inject, Injectable, signal } from "@angular/core";
import { EntrepreneurProspectDialogFuncData } from "@interfaces";
import { AppService, FuncService } from "../../../../services";


@Injectable({ providedIn: 'root' })
export class EntrepreneurProspectDialogDataService {

	private readonly func = inject(FuncService);
	private readonly app = inject(AppService);

	public readonly dialogData = signal<EntrepreneurProspectDialogFuncData | undefined>(undefined);
	public readonly isReadonly = computed(() => !this.app.data().permissions.canEnrollEntrepreneurs);

	public async loadData(personId: number, accProspectId: number | undefined) {
		const data = await this.func.entrepreneurProspect.getDialogData({ personId, accProspectId });
		this.dialogData.set(data);
	}

	public async reloadData() {
		const dialogData = this.dialogData();
		if (!dialogData || !dialogData.details) return;

		await this.loadData(dialogData.details.personId, dialogData.details.accProspectId);
	}


	public async markProspectAsClosed(isMarkedClosed: boolean) {
		const dialogData = this.dialogData();
		if (dialogData && dialogData.details) {
			const bool = await this.func.accLead.markProspectAsClosed({ isMarkedClosed, accLeadId: dialogData.details.accLead.accLeadId });
			if (bool) await this.reloadData();
		}
	}
}